import { FC, useEffect, useRef } from 'react';
import { useStadiometry } from '@/common/hook/Amap/useStadiometry';
import { DISTRICT_LEVEL } from '@/common/components/AMap/ts-config';
import useLatest from '@/common/hook/useLatest';
import { CLUSTER_CRITICAL_COUNT } from '@/common/enums/business/siteselectionmap';

/**
 * @Description 区以下的小聚合
 */
const ClusterMarkerOfDistrict: FC<{
  level,
  mapIns,
  data, // 商圈数据
}> = ({
  level,
  mapIns,
  data, // 商圈数据
}) => {
  const clusterMarkerRef: any = useRef();
  const isStadiometry: any = useStadiometry(); // 是否在使用测距功能
  const isStadiometryRef = useRef(isStadiometry);
  const levelRef = useLatest(level);

  useEffect(() => {
    if (!mapIns || level !== DISTRICT_LEVEL) return;
    const len = data?.length; // 商圈数据个数
    // 不满足聚合条件
    if (len <= CLUSTER_CRITICAL_COUNT) {
      clusterMarkerRef.current && clusterMarkerRef.current.setMap(null);
      clusterMarkerRef.current = null;
      return;
    }
    loadMarker();
  // }, [mapIns, data, showRail]);
  }, [mapIns, data, level]);

  useEffect(() => {
    isStadiometryRef.current = isStadiometry;
  }, [isStadiometry]);

  // 以避免高德地图在新数据获取到之前，根据旧数据重新聚合，导致页面前后两次聚合
  // useEffect(() => {
  //   mapIns?.on('zoomend', clearDistrictCluster);
  //   return () => {
  //     mapIns?.off('zoomend', clearDistrictCluster);
  //   };
  // }, [mapIns]);

  const loadMarker = () => {
    clusterMarkerRef.current && clusterMarkerRef.current.setMap(null);
    clusterMarkerRef.current = null;
    const points = data.filter((item) => +item?.lng && +item?.lat).map((item: any) => ({
      ...item,
      lnglat: [+item.lng, +item.lat]
    }));
    const clusterMarker = new window.AMap.MarkerCluster(mapIns, points, {
      gridSize: 100, // 设置网格像素大小
      // maxZoom: BUSINESS_ZOOM, // 最大的聚合级别，大于等于该级别就不进行相应的聚合。
      maxZoom: 20, // 最大的聚合级别，大于等于该级别就不进行相应的聚合。
      // 注意这里高德内部有判断逻辑，如果的count是1时，会调用renderMarker的显示
      renderClusterMarker: customClusterMarker, // 自定义聚合点样式
      renderMarker: customClusterMarker, // 自定义非聚合点样式
    });
    clusterMarkerRef.current = clusterMarker;
    if (levelRef.current === DISTRICT_LEVEL) {
      clusterMarkerRef.current.setMap(mapIns);
    }
    // mapIns.add(clusterMarkerRef.current);
  };

  const customClusterMarker = (context: any) => {
    /**
     * context 结构，有两种情况，区别是renderMarker调用时没有clusterData，而是data
     * {
     *  clusterData: [{xxx}, {xxx}...] // renderClusterMarker调用时有该字段
     *  data: [], // renderMarker调用时有该字段
     *  count: 20, // 聚合的数量
     *  indexs: xxx,
     *  marker: {}, // 当前覆盖物
     * }
     */

    const { marker, count } = context;
    marker && marker._opts && (marker._opts.bubble = true); // 允许冒泡
    marker?.setContent(`<div class="clusterMarkerOfDistrict">${count}</div>`);

    context.marker.on('click', (e) => {
      // 在使用工具箱的测距功能时，不执行点击后的逻辑
      if (isStadiometryRef.current) return;
      mapIns.setZoomAndCenter(mapIns.getZoom() + 2, e?.lnglat, false, 100);
    });
  };
  useEffect(() => {
    if (level !== DISTRICT_LEVEL) {
      clusterMarkerRef.current && clusterMarkerRef.current.setMap(null);
      clusterMarkerRef.current = null;
    }
  }, [level]);
  return (
    <></>
  );
};

export default ClusterMarkerOfDistrict;

